import { useMemo, useState } from 'react';
import { articles, categories, getArticlesByCategory, sortArticles } from '@/lib/content';
import ArticleCard from '@/components/base/ArticleCard';
import type { Article } from '@/types/content';

const tabs = [{ slug: 'all', name: '全部' }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function LatestFeed() {
  const [active, setActive] = useState('all');
  const [visible, setVisible] = useState(6);

  const list = useMemo(() => {
    const base = active === 'all' ? articles : getArticlesByCategory(active);
    return sortArticles(base, 'new');
  }, [active]);

  const shown = list.slice(0, visible);

  return (
    <section id="latest" className="w-full scroll-mt-24 bg-background-50 px-4 py-12 md:px-8 md:py-16">
      <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <span className="flex items-center gap-1 text-sm font-bold text-accent-700">
            <i className="ri-newspaper-line" aria-hidden="true"></i>
            最新爆料
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            刚刚上新的离谱合集
          </h2>
        </div>
        <p className="text-sm text-foreground-600">切换下方栏目，只看你想看的类型</p>
      </div>

      <div className="mb-6 flex flex-wrap gap-1 rounded-full bg-background-100 p-1">
        {tabs.map((tab) => (
          <button
            key={tab.slug}
            type="button"
            onClick={() => {
              setActive(tab.slug);
              setVisible(6);
            }}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              active === tab.slug
                ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                : 'text-foreground-600 hover:bg-background-200'
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {shown.length === 0 ? (
        <p className="rounded-lg border border-dashed border-background-300 py-16 text-center text-sm text-foreground-500">
          这个栏目暂时还没上新，先去看看其他瓜吧。
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {shown.map((item: Article) => (
            <ArticleCard key={item.id} article={item} />
          ))}
        </div>
      )}

      {visible < list.length && (
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((v) => v + 6)}
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-bold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-add-line" aria-hidden="true"></i>
            加载更多瓜
          </button>
        </div>
      )}
    </section>
  );
}